var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"align-center color-suva-grey d-flex empty-state-view-height font-size-lg justify-center",attrs:{"cols":"12>"}},[_vm._t("default",function(){return [_vm._v("Empty")]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }